// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2pY5A","footer":"ReportModalFilter_footer__3Vu4l"};